<template>
  <div class="flex">
    <img id="image" width="100" />
    <FileUpload
      mode="basic"
      name="demo[]"
      url="./upload.php"
      accept="image/*"
      :maxFileSize="1000000"
      customUpload
      @uploader="customBase64Uploader"
      @select="onSelectedFiles"
      class="ml-2"
      :chooseLabel="props.label"
    />
  </div>

  <small v-if="v$.value.$error" class="p-error">File is required</small>
</template>
<script setup>
import { ref, computed } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import ImageDb from '@/stores/imageDB'
import { useUserStore } from '@/stores/userStore'

const props = defineProps({
  file_uuid: String,
  entity_uuid: String,
  entity_type: String,
  type: String,
  required: Boolean,
  label: {
    type: String,
    default: 'Choose'
  }
})
const file = ref(undefined)

const imageUUID = ref(props.file_uuid)

if (imageUUID.value != undefined) {
  ImageDb.url(imageUUID.value).then((res) => (document.querySelector('#image').src = res))
}
const rules = computed(() => {
  const v = {}
  if (props.required) {
    v.value = { required }
  } else {
    v.value = {}
  }
  return v
})

const v$ = useVuelidate(rules, { file })

const customBase64Uploader = async (event) => {
  let blob = await fetch(file.value.objectURL).then((r) => r.blob()) //blob:url
  const { authenticationKey, partner } = useUserStore()
  let newImageUUID = ImageDb.add(blob)
  const imageObj = {
    type: props.type,
    type_uuid: props.entity_uuid,
    uuid: newImageUUID,
    entity_type: props.entity_type,
    apiKey: authenticationKey,
    partnerCode: partner.code,
  }

  ImageDb.upload(imageObj)
}
const onSelectedFiles = (event) => {
  file.value = event.files[0]
  document.querySelector('#image').src = file.value.objectURL
}
</script>
